"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseProcessLaneSet = void 0;
const index_1 = require("../../Model/index");
const TypeFactory_1 = require("../TypeFactory");
function parseProcessLaneSet(data) {
    var _a;
    const laneSetData = (_a = data[index_1.BpmnTags.Lane.LaneSet]) !== null && _a !== void 0 ? _a : data[index_1.BpmnTags.LaneProperty.ChildLaneSet];
    if (!laneSetData) {
        return undefined;
    }
    const lanesRaw = (0, TypeFactory_1.getModelPropertyAsArray)(laneSetData, index_1.BpmnTags.Lane.Lane);
    const laneSet = new index_1.Model.ProcessElements.LaneSet();
    laneSet.lanes = [];
    if (!lanesRaw) {
        return laneSet;
    }
    for (const laneRaw of lanesRaw) {
        const lane = (0, TypeFactory_1.createObjectWithCommonProperties)(laneRaw, index_1.Model.ProcessElements.Lane);
        lane.name = laneRaw.name;
        const flowNodeReferences = (0, TypeFactory_1.getModelPropertyAsArray)(laneRaw, index_1.BpmnTags.LaneProperty.FlowNodeRef);
        const laneHasNoFlowNodes = !((flowNodeReferences === null || flowNodeReferences === void 0 ? void 0 : flowNodeReferences.length) > 0);
        if (laneHasNoFlowNodes) {
            return laneSet;
        }
        lane.flowNodeReferences = flowNodeReferences.map((reference) => reference.trim());
        if (laneRaw[index_1.BpmnTags.LaneProperty.ChildLaneSet]) {
            lane.childLaneSet = parseProcessLaneSet(laneRaw);
        }
        laneSet.lanes.push(lane);
    }
    return laneSet;
}
exports.parseProcessLaneSet = parseProcessLaneSet;
//# sourceMappingURL=ProcessLaneSetParser.js.map